import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { environment } from 'environments/environment'
import { Document } from 'app/models/document'
import { FileType } from 'app/models/file-type.enum'
import { SharepointFile } from 'app/models/sharepoint-data'
import { UPTOPResponse, UPTOPResult } from 'app/models/uptop'
import { SharepointService } from 'app/services/sharepoint.service'
import { AssetSortingType } from 'app/models/asset-sorting-type'
import { Source } from 'app/models/source.enum'
import { PictureParkService } from './picture-park.service'
import { CompetitionService } from 'app/services/competition.service'

@Injectable()
export class DocumentService {

  private apiUrl = environment.api.url + environment.api.content.url

  constructor(
    private http: HttpClient,
    private pictureParkService: PictureParkService,
    private competitionService: CompetitionService,
    private sharepointService: SharepointService) {
  }

  getAll(
    searchText?: string,
    sortingType?: AssetSortingType,
    lastEvaluatedKey?: any
  ): Observable<UPTOPResult> {
    let params = new HttpParams()

    params = params.append('op', (searchText && searchText !== '') ? environment.api.content.type.search.op : environment.api.content.type.repository)
    params = params.append('search_type', environment.api.content.type.search.doctype)
    params = params.append('source', Source.Document)
    params = searchText ? params.append('search_term', searchText) : params
    params = sortingType ? params.append('filter', sortingType.id) : params

    let headers = new HttpHeaders()
    if (lastEvaluatedKey) {
      headers = headers.append('lastevaluatedkey', btoa(JSON.stringify(lastEvaluatedKey)))
    }

    return this.http
      .get<UPTOPResult>(this.apiUrl, {headers, params})
      .map((res) => res as UPTOPResult)
      .catch((err) => Observable.throw(err || 'ServerErr'))
  }

  getById(id: string): Observable<Document> {
    let params = new HttpParams()
    params = params.append('op', environment.api.content.type.document.op)
    params = params.append('document', id)

    return this.http
      .get<Document>(this.apiUrl, {params})
      .catch(err => Observable.throw(err || 'ServerErr'))
  }
}



// WEBPACK FOOTER //
// ./src/app/services/document.service.ts